import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// 导入各个模块
let moduleFn = require.context('./modules', false, /\.js$/);
let modules = moduleFn.keys().reduce((p, c) => {
	let mod = moduleFn(c).default;
	mod = { ...mod, namespaced: true };
	let modName = c.match(/\.\/(\w+)\.js$/)[1];
	p[modName] = mod;
	return p;
}, {});

export default new Vuex.Store({
  modules,
  state: {
    // 数据加载状态
    loading: false,
    // 最后更新时间
    lastUpdateTime: null
  },
  mutations: {
    // 设置加载状态
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    // 更新最后更新时间
    SET_LAST_UPDATE_TIME(state, time) {
      state.lastUpdateTime = time
    }
  },
  actions: {
    // 获取所有数据
    async fetchAllData({ dispatch }) {
      const maxRetries = 3
      let retryCount = 0
      
      while (retryCount < maxRetries) {
        try {
          // 根据当前区域状态获取大屏数据
          const currentRegion = this.state.region.currentRegion
          const regionParam = currentRegion.level === 'city' 
            ? { region: currentRegion.mapName } 
            : {}
          
          // 先获取大屏完整数据，确保派生字段可用
          await dispatch('screen/fetchBigScreenData', regionParam)

          // 并发获取其他模块数据（不含渠道占比）
          await Promise.all([
            dispatch('book/fetchBookStatistics'),
            dispatch('sales/fetchSalesCategory'),
            dispatch('todaySales/fetchTodaySales'),
            dispatch('map/fetchHunanMapData'),
            dispatch('textbook/fetchTextbookStatistics'),
            dispatch('order/fetchOrderComparison'),
            dispatch('city/fetchCityChannelComparison')
          ])

          // 最后获取渠道占比（将优先使用大屏数据派生）
          await dispatch('sales/fetchChannelSales')
          // 获取单品种销售排行（默认近7天）
          await dispatch('sales/fetchSalesRanking')
          
          console.log('所有数据获取成功')
          return // 成功则退出重试循环
          
        } catch (error) {
          retryCount++
          console.error(`数据获取失败 (尝试 ${retryCount}/${maxRetries}):`, error)
          
          if (retryCount >= maxRetries) {
            console.error('达到最大重试次数，数据获取最终失败')
            throw error
          }
          
          // 等待一段时间后重试
          const delay = Math.min(1000 * Math.pow(2, retryCount - 1), 5000) // 指数退避，最大5秒
          console.log(`等待 ${delay}ms 后重试...`)
          await new Promise(resolve => setTimeout(resolve, delay))
        }
      }
    },
    // 切换区域并重新获取数据
    async switchRegion({ dispatch }, { level, name, mapName, adcode }) {
      try {
        // 更新区域状态
        await dispatch('region/updateCurrentRegion', { level, name, mapName, adcode })
        
        // 重新获取所有数据
        await dispatch('fetchAllData')
      } catch (error) {
        console.error('区域切换失败:', error)
        throw error
      }
    },
    // 重置所有数据的action
    async resetAllData({ commit }) {
      // 调用各个模块的重置方法
      commit('region/RESET_REGION')
      commit('screen/RESET_SCREEN')
      commit('book/RESET_BOOK')
      commit('sales/RESET_SALES')
      commit('member/RESET_MEMBER')
      commit('todaySales/RESET_TODAY_SALES')
      commit('map/RESET_MAP')
      commit('textbook/RESET_TEXTBOOK')
      commit('order/RESET_ORDER')
      commit('city/RESET_CITY')
      
      // 征订大屏相关模块
      commit('provinceCoverage/RESET_DATA')
      commit('cityCoverage/RESET_DATA')
      commit('categoryAmount/RESET_DATA')
      commit('keyMetrics/RESET_DATA')
      commit('provinceTrend/RESET_DATA')
      commit('todayOverview/RESET_DATA')
      commit('cityAmountShare/RESET_DATA')
      commit('cityChannelCompare/RESET_DATA')
      
      // 添加短暂延迟确保状态重置完成
      await new Promise(resolve => setTimeout(resolve, 100))
      console.log('数据重置操作完成')
    }
  },
  getters: {
    // 全局 loading 状态
    loading: state => state.loading,
    lastUpdateTime: state => state.lastUpdateTime
  }
})